import { BaseExtension, NodeSpec } from '@lyearn/lygo-core';

export default class CourseLessonPage extends BaseExtension {
  get schema(): NodeSpec {
    return {};
  }

  get name(): string {
    return 'ly__page';
  }
}
